// デモ用インメモリ・サーバ（バックエンド不要のクリックデモ）。
// REACT_APP_DEMO=1 のビルドでのみ installDemo から使われる。実DB・実LINEには一切繋がらない。
// 状態は localStorage に保存し、リロードしても保持（「リセット」で初期化）。

const LS_KEY = "mpDemoState";
// seed（初期デモデータ）を変えたら上げる。localStorage のバージョンが古ければ自動で作り直す
// （＝データ変更後にユーザーが手動リセットしなくても反映される）。
const SEED_VERSION = 15;

function p2(n) { return String(n).padStart(2, "0"); }
function nowHM() { const d = new Date(); return `${p2(d.getHours())}:${p2(d.getMinutes())}`; }
function nowISO() { const d = new Date(); return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}T${p2(d.getHours())}:${p2(d.getMinutes())}:00`; }
function todayMD() { const d = new Date(); return `${d.getMonth() + 1}/${d.getDate()}`; }
function todayWD() { return ["日", "月", "火", "水", "木", "金", "土"][new Date().getDay()]; }
function ymd(d) { return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`; }

// 祝日（デモ用・2025-2026）。※本番は BE の jpholiday＋/api/employee/holidays に置き換え予定。
// 出典: 内閣府の国民の祝日（holidays-jp 経由で取得）。振替休日・国民の休日を含む。
const HOLIDAYS = {
  "2025-01-01": "元日", "2025-01-13": "成人の日", "2025-02-11": "建国記念の日",
  "2025-02-23": "天皇誕生日", "2025-02-24": "振替休日", "2025-03-20": "春分の日",
  "2025-04-29": "昭和の日", "2025-05-03": "憲法記念日", "2025-05-04": "みどりの日",
  "2025-05-05": "こどもの日", "2025-05-06": "振替休日", "2025-07-21": "海の日",
  "2025-08-11": "山の日", "2025-09-15": "敬老の日", "2025-09-23": "秋分の日",
  "2025-10-13": "スポーツの日", "2025-11-03": "文化の日", "2025-11-23": "勤労感謝の日",
  "2025-11-24": "振替休日",
  "2026-01-01": "元日", "2026-01-12": "成人の日", "2026-02-11": "建国記念の日",
  "2026-02-23": "天皇誕生日", "2026-03-20": "春分の日", "2026-04-29": "昭和の日",
  "2026-05-03": "憲法記念日", "2026-05-04": "みどりの日", "2026-05-05": "こどもの日",
  "2026-05-06": "振替休日", "2026-07-20": "海の日", "2026-08-11": "山の日",
  "2026-09-21": "敬老の日", "2026-09-22": "国民の休日", "2026-09-23": "秋分の日",
  "2026-10-12": "スポーツの日", "2026-11-03": "文化の日", "2026-11-23": "勤労感謝の日",
};
// 祝日でも出勤登録がある例（日付→出勤した社員IDの配列）。実運用の「祝日出勤」ケースをデモで示す。
// 祝日は原則休みだが、ここに登録された社員だけは出勤（勤怠グリッド／ロスターに表示される）。
const HOLIDAY_WORK = {
  "2026-05-04": [2, 3], // みどりの日に 佐藤 太郎・鈴木 一郎 が出勤
  "2026-05-06": [1],    // 振替休日に 田中 花子 が出勤
  "2026-07-20": [1],    // 海の日に 田中 花子 が出勤（当月・未来日＝予定として表示）
};

// 経営者の「勤怠管理（日付別）」用のデモデータ生成。
// 実DBの代わりに、指定日の全アクティブ社員の勤怠状態を決定論的に組み立てる
// （土日=休み／未来日=未出勤／平日=出退勤。今日は先頭社員を勤務中にして"今動いてる"感を出す）。
// 日報は Markdown で記述される想定（本実装予定）。デモも Markdown で用意し、
// 経営者の勤怠一覧ではレンダリング（プレビュー）表示になる。
const DEMO_REPORTS = [
  `## 本日の業務

午前は受付とレッスン準備、午後は体験レッスンを2件対応しました。退勤前に事務処理をまとめて実施しています。`,
  `## 在宅勤務

発表会の告知文面を作成し、共有フォルダに保存しました。あわせて問い合わせ対応も数件行っています。`,
  `## 事務作業

スタジオの備品を点検し、発注リストを更新しました。翌週のレッスン割り当ても確認済みです。`,
  `## 体験レッスン

体験レッスンを2件対応し、うち1件はその場でご入会いただきました。対応記録を更新しています。`,
  `## 月次まとめ

月末の締め作業を完了し、SNS投稿の下書きを作成しました。詳細は共有ダッシュボードを参照してください。`,
];
// 承認済みの休み申請が指定日を含むか（勤怠グリッドと申請リストの整合用）。
function hasApprovedLeave(name, dateStr) {
  return state.leaveList.some((l) => l.employee_name === name && l.status === "approved" && dateStr >= l.date_from && dateStr <= l.date_to);
}
function demoAttendanceByDate(dateStr) {
  const d = new Date(`${dateStr}T00:00:00`);
  const wd = d.getDay(); // 0=日 .. 6=土
  const dom = d.getDate();
  const todayStr = ymd(new Date());
  const isToday = dateStr === todayStr;
  const isFuture = dateStr > todayStr;
  const active = state.empList.filter((e) => e.is_active);
  return active.map((e, i) => {
    const baseInfo = { employee_id: e.id, employee_name: e.name };
    if (wd === 0 || wd === 6) return { ...baseInfo, status: "dayoff", work_mode: null, clock_in: null, clock_out: null, daily_report: "" };
    if (isFuture) return { ...baseInfo, status: "none", work_mode: null, clock_in: null, clock_out: null, daily_report: "" };
    // 承認済みの休み申請がある日は「休み」として扱う（申請リストとの矛盾を防ぐ）。
    if (hasApprovedLeave(e.name, dateStr)) return { ...baseInfo, status: "dayoff", work_mode: null, clock_in: null, clock_out: null, daily_report: "" };
    // 祝日は原則休み。ただし HOLIDAY_WORK に登録がある社員は出勤（＝祝日出勤の実例）。
    if (HOLIDAYS[dateStr] && !(HOLIDAY_WORK[dateStr] || []).includes(e.id)) return { ...baseInfo, status: "dayoff", work_mode: null, clock_in: null, clock_out: null, daily_report: "" };
    const mode = (e.id + dom) % 3 === 0 ? "remote" : "office";
    const inTotal = 9 * 60 + 52 + ((e.id * 3 + dom) % 9); // 09:52〜10:00
    const cin = `${dateStr}T${p2(Math.floor(inTotal / 60))}:${p2(inTotal % 60)}:00`;
    if (isToday && i === 0) return { ...baseInfo, status: "open", work_mode: mode, clock_in: cin, clock_out: null, daily_report: "" };
    const outH = 18 + ((e.id + dom) % 2); // 18 or 19時台
    const outM = 5 + ((e.id * 5 + dom) % 40);
    const cout = `${dateStr}T${p2(outH)}:${p2(outM)}:00`;
    return { ...baseInfo, status: "closed", work_mode: mode, clock_in: cin, clock_out: cout, daily_report: DEMO_REPORTS[(e.id + dom) % DEMO_REPORTS.length] };
  });
}

// 経営者の月別ビュー用：月内の各日付×各社員の勤怠グリッド。未来日は含めない（新しい日付が上）。
function demoAttendanceByMonth(ym) {
  const year = parseInt(ym.slice(0, 4), 10);
  const month = parseInt(ym.slice(4, 6), 10);
  const lastDay = new Date(year, month, 0).getDate();
  const todayStr = ymd(new Date());
  // last_name＝姓のみ（スマホの月間カレンダーで姓だけコンパクト表示する用）。デモ名は「田中 花子」の
  // スペース区切りなので先頭要素を姓として抽出（本番APIは姓フィールドを別途返す）。
  const employees = state.empList.filter((e) => e.is_active).map((e) => ({ id: e.id, name: e.name, last_name: e.name.split(/\s+/)[0] }));
  const days = [];
  const holidays = {}; // 表示中の月の祝日（{ "YYYY-MM-DD": 祝日名 }）。カレンダーが月ごとに正確な祝日を出せるよう含める。
  const holidayWork = {}; // 表示中の月の「祝日出勤」（{ "YYYY-MM-DD": 社員IDの配列 }）。未来日でも予定として出せるよう含める。
  for (let dd = 1; dd <= lastDay; dd++) {
    const dateStr = `${year}-${p2(month)}-${p2(dd)}`;
    if (HOLIDAYS[dateStr]) holidays[dateStr] = HOLIDAYS[dateStr];
    if (HOLIDAY_WORK[dateStr]) holidayWork[dateStr] = HOLIDAY_WORK[dateStr];
    if (dateStr > todayStr) continue; // 未来日は勤怠グリッドには出さない（祝日・祝日出勤は上で拾う）
    days.push({ date: dateStr, cells: demoAttendanceByDate(dateStr) });
  }
  days.reverse();
  return { ym, employees, days, holidays, holidayWork };
}

// 社員の勤怠履歴デモ。2025-11〜当月を「連続で」生成する（間を空けると月ナビの挙動が分かりづらいため）。
// 日報は Markdown で記述される想定（退勤時にMarkdownで保存）。デモもMarkdownで用意し、
// 社員自身の勤怠履歴でもレンダリング（プレビュー）表示になることを確認できるようにする。
const OWN_REPORTS = [
  `## 本日の業務

- 午前は受付と**レッスン準備**
  - スタジオAの音響チェック
  - 配布資料の印刷
- 午後は体験レッスンを2件対応

### 残タスク

- [x] 体験レッスンの対応記録
- [ ] 見学者への礼状メール

退勤前に事務処理をまとめて実施しました。`,
  `## 在宅勤務

発表会の告知文面を作成し、共有フォルダに保存しました。

1. 告知文のドラフト作成
2. 画像の差し替え
3. 問い合わせ対応（数件）`,
  `## 事務作業

スタジオAの鏡と備品を点検し、**発注リスト**を更新しました。

| 備品 | 在庫 | 対応 |
|:---|---:|:---:|
| バレエバー | 2 | 発注済み |
| タオル | 40 | ~~発注~~ 見送り |`,
  `## 体験レッスン

体験レッスンを2件対応し、うち1件はその場でご入会いただきました。

> 対応記録は共有ダッシュボードに更新済みです。`,
  `## 在宅勤務

座席割り当てと来場者名簿を整理しました。`,
  "", // 日報なしの日も混ぜる（一覧の「-」表示確認用）
];
function buildOwnAttendances() {
  const now = new Date();
  const curY = now.getFullYear();
  const curM = now.getMonth() + 1;
  const curD = now.getDate();
  const modes = ["office", "remote", "office", "office", "remote"];
  // カレンダー（時間訂正）に打刻ドットを並べるため、平日は基本すべて勤怠記録を作る。
  // ただし次の日は記録を作らない：
  //  ・SKIP  = 承認済みの過去の休み（勤怠と休みの矛盾を防ぐ。leaveMine の approved 過去日と一致させる）
  //  ・FORGOT= 丸一日打刻を忘れた平日（時間訂正の「新規登録」を実演するためのギャップ）
  const SKIP = new Set(["2026-06-25"]);
  const FORGOT = new Set(["2026-07-07", "2026-06-17", "2026-05-13"]);
  const out = [];
  let id = 100;
  let y = 2025;
  let m = 11; // 去年11月から
  while (y < curY || (y === curY && m <= curM)) {
    const daysInMonth = new Date(y, m, 0).getDate(); // m は1始まりなので day0 で当月末日
    for (let d = 1; d <= daysInMonth; d += 1) {
      if (y === curY && m === curM && d >= curD) continue; // 当月は今日より前だけ
      const dstr = `${y}-${p2(m)}-${p2(d)}`;
      if ([0, 6].includes(new Date(`${dstr}T00:00:00`).getDay())) continue; // 週末は勤務なし（会社は土日休み）
      if (SKIP.has(dstr) || FORGOT.has(dstr)) continue; // 休み・打刻忘れの日は記録なし
      const mode = modes[(m + d) % modes.length];
      const cinM = 50 + ((m + d * 2) % 9); // 09:50〜09:58
      const outH = 18 + ((d + m) % 2); // 18 or 19時台
      const outM = 5 + ((d * 3 + m * 7) % 45);
      out.push({
        id,
        clock_in: `${dstr}T09:${p2(cinM)}:00`,
        clock_out: `${dstr}T${p2(outH)}:${p2(outM)}:00`,
        work_mode: mode,
        in_office: mode === "office",
        status: "closed",
        daily_report: OWN_REPORTS[(m + d) % OWN_REPORTS.length],
      });
      id += 1;
    }
    m += 1;
    if (m > 12) { m = 1; y += 1; }
  }
  out.sort((a, b) => (a.clock_in < b.clock_in ? 1 : -1)); // 新しい順
  return out;
}

// 賞与（ボーナス）のデモ。月次と区別する kind:"bonus" と label（賞与名）を持つ。
// 支給月(year_month)は月次と同じ体系。PDFは動作確認用に月次と同じ /demo/payslip-YYYYMM.pdf を流用する。
// 社員本人（デモ太郎）が受け取った賞与。年をまたいで「賞与セクション」表示を確認できるよう複数年に配置。
const BONUS_MINE = [
  { id: 701, year_month: "202606", uploaded_at: "2026-06-30T10:00:00", kind: "bonus", label: "夏季賞与" },
  { id: 702, year_month: "202512", uploaded_at: "2025-12-10T10:00:00", kind: "bonus", label: "冬季賞与" },
  { id: 703, year_month: "202506", uploaded_at: "2025-06-30T10:00:00", kind: "bonus", label: "夏季賞与" },
];
// 経営者側（全社員×賞与）のデモ。(year_month, label) で「賞与枠」がまとまる。
// 2026夏季は鈴木一郎を未登録にして「アップロード枠が出る」状態を確認できるようにしている。
const BONUS_LIST = [
  { id: 751, employee_name: "田中 花子", year_month: "202606", uploaded_at: "2026-06-30T10:00:00", kind: "bonus", label: "夏季賞与" },
  { id: 752, employee_name: "佐藤 太郎", year_month: "202606", uploaded_at: "2026-06-30T10:00:00", kind: "bonus", label: "夏季賞与" },
  { id: 753, employee_name: "田中 花子", year_month: "202512", uploaded_at: "2025-12-10T10:00:00", kind: "bonus", label: "冬季賞与" },
  { id: 754, employee_name: "佐藤 太郎", year_month: "202512", uploaded_at: "2025-12-10T10:00:00", kind: "bonus", label: "冬季賞与" },
  { id: 755, employee_name: "鈴木 一郎", year_month: "202512", uploaded_at: "2025-12-10T10:00:00", kind: "bonus", label: "冬季賞与" },
];

// 給与明細のデモ（会社設立2023-11〜2026-06の各月。当月2026-07は未発行）。年ごと4×3グリッド表示の確認用。
function buildPayslips() {
  const months = [];
  for (let y = 2023; y <= 2026; y += 1) {
    const from = y === 2023 ? 11 : 1;
    const to = y === 2026 ? 6 : 12;
    for (let m = from; m <= to; m += 1) months.push([y, m]);
  }
  months.reverse(); // 新しい順
  let id = 60;
  const monthly = months.map(([y, m]) => {
    id += 1;
    const mm = p2(m);
    return { id, year_month: `${y}${mm}`, uploaded_at: `${y}-${mm}-25T10:00:00` };
  });
  return [...monthly, ...BONUS_MINE];
}

// 給与明細アップロード管理（経営者）のデモ。全社員×2023-11〜2026-06を「発行済み」にする。
// 当月(2026-07)以降は未発行のまま＝アップロード枠が出る。
function buildPayslipList() {
  const names = ["田中 花子", "佐藤 太郎", "鈴木 一郎"];
  const months = [];
  for (let y = 2023; y <= 2026; y += 1) {
    const from = y === 2023 ? 11 : 1;
    const to = y === 2026 ? 6 : 12;
    for (let m = from; m <= to; m += 1) months.push([y, m]);
  }
  let id = 200;
  const out = [];
  months.forEach(([y, m]) => {
    const mm = p2(m);
    names.forEach((name) => {
      id += 1;
      out.push({ id, employee_name: name, year_month: `${y}${mm}`, uploaded_at: `${y}-${mm}-25T10:00:00` });
    });
  });
  return [...out, ...BONUS_LIST];
}

// 初期データ（勤怠マイページのモックと同一）。
// 毎週くり返す予定の展開（実BE views_employee_calendar と同じ考え方＝ルール1行を表示時に各回へ広げる）。
// 展開の窓は実BEの既定（3ヶ月前〜12ヶ月後）に合わせる。ここを実装しないと「demoでは毎週の予定が
// 1回しか出ないのに本番では毎週出る」という食い違いが起きる。
const WD_CODES_DEMO = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
function localISO(d) { return `${ymd(d)}T${p2(d.getHours())}:${p2(d.getMinutes())}:00`; }
// 予定の保存内容（追加・修正で共通）。実BEと同じく、くり返しを解除したら終了日も残さない。
function calendarFields(body) {
  const weekdays = body.repeat_weekdays || "";
  const start = weekdays ? shiftToFirstWeekday(body.start, weekdays) : body.start;
  const shift = new Date(start).getTime() - new Date(body.start).getTime();
  return {
    title: body.title,
    start,
    end: body.end ? localISO(new Date(new Date(body.end).getTime() + shift)) : null,
    allDay: body.allday || false,
    repeatWeekdays: weekdays,
    repeatUntil: weekdays ? (body.repeat_until || null) : null,
  };
}
// くり返しの開始を最初に当たる曜日へ寄せる（実BE _normalize_repeat_anchor と同じ）。
function shiftToFirstWeekday(start, weekdays) {
  const codes = weekdays.split(",").filter(Boolean);
  const d = new Date(start);
  for (let i = 0; i < 7; i += 1) {
    if (codes.includes(WD_CODES_DEMO[d.getDay()])) break;
    d.setDate(d.getDate() + 1);
  }
  return String(start).length <= 10 ? ymd(d) : localISO(d);
}
function expandCalendar(rows, query) {
  const out = [];
  // 実BEと同じく ?from=&to= で展開期間を受ける（未指定は今日の3ヶ月前〜12ヶ月後）。
  const qf = query && query.get("from");
  const qt = query && query.get("to");
  const from = qf ? new Date(`${qf}T00:00:00`) : (() => { const d = new Date(); d.setMonth(d.getMonth() - 3); return d; })();
  const to = qt ? new Date(`${qt}T23:59:59`) : (() => { const d = new Date(); d.setMonth(d.getMonth() + 12); return d; })();
  rows.forEach((e) => {
    const codes = (e.repeatWeekdays || "").split(",").filter(Boolean);
    if (!codes.length) { out.push({ ...e, repeat: false, seriesId: e.id }); return; }
    const [sy, sm, sd] = e.start.slice(0, 10).split("-").map(Number);
    const time = e.start.slice(10); // "THH:MM:SS"（終日なら空）
    const durMs = e.end ? new Date(e.end).getTime() - new Date(e.start).getTime() : null;
    const until = e.repeatUntil ? new Date(`${e.repeatUntil}T23:59:59`) : null;
    const begin = new Date(Math.max(new Date(sy, sm - 1, sd).getTime(), from.getTime()));
    for (const d = new Date(begin); d <= to; d.setDate(d.getDate() + 1)) {
      if (until && d > until) break;
      if (!codes.includes(WD_CODES_DEMO[d.getDay()])) continue;
      const ds = ymd(d);
      const start = `${ds}${time}`;
      out.push({
        ...e,
        id: `${e.id}@${ds}`,
        seriesId: e.id,
        repeat: true,
        seriesStart: e.start.slice(0, 10),
        start,
        // toISOString() はUTCに直してしまい9時間ずれるので、ローカルのまま文字列を組む。
        end: durMs == null ? null : localISO(new Date(new Date(start).getTime() + durMs)),
      });
    }
  });
  return out.sort((a, b) => String(a.start).localeCompare(String(b.start)));
}

function initialState() {
  return {
    _v: SEED_VERSION, // seedバージョン（古ければ load で作り直す）
    role: "employee", // employee | executive
    today: {
      status: "off", // off(未出勤) | working | closed
      shift: { start: "09:00", end: "18:00", mode: "office", is_dayoff: false },
      office_name: "本社スタジオ", office_radius: 100,
      in_office: false, work_mode: null, clock_in: null, clock_out: null, elapsed_min: 0,
    },
    curAttId: null,
    attendances: buildOwnAttendances(),
    recent: [
      { date: "6/30", weekday: "火", clock_in: "09:58", clock_out: "19:05", work_mode: "office", status: "closed" },
      { date: "6/26", weekday: "金", clock_in: "10:03", clock_out: "18:40", work_mode: "remote", status: "closed" },
      { date: "6/25", weekday: "木", clock_in: "09:55", clock_out: "19:12", work_mode: "office", status: "closed" },
      { date: "6/24", weekday: "水", clock_in: "10:01", clock_out: "19:00", work_mode: "office", status: "closed" },
      { date: "6/23", weekday: "火", clock_in: "09:52", clock_out: "18:33", work_mode: "remote", status: "closed" },
    ],
    calendar: [
      { id: 1, title: "発表会リハーサル", start: "2026-07-03T14:00:00", end: "2026-07-03T16:00:00" },
      { id: 2, title: "体験レッスン枠", start: "2026-07-05T10:00:00", end: null },
      { id: 3, title: "スタッフMTG", start: "2026-07-05T18:00:00", end: null },
      { id: 4, title: "エアコン点検", start: "2026-07-08T13:00:00", end: null },
      { id: 5, title: "給与明細アップロード期限", start: "2026-07-10", end: null, allDay: true },
      { id: 6, title: "全体清掃", start: "2026-07-15T09:00:00", end: "2026-07-15T10:00:00" },
      // 連日（複数日）予定の例。LINE抽出等で入り得る＝Mac風の帯で表示されるか確認用。
      { id: 7, title: "夏季集中レッスン", start: "2026-07-13T10:00:00", end: "2026-07-15T12:00:00" }, // 週内で3日
      { id: 8, title: "発表会リハ週間", start: "2026-07-16", end: "2026-07-20", allDay: true }, // 土日をまたぎ翌週へ分割
      // 毎週くり返す予定（1行だけ持ち、一覧を返すときに各週へ展開する＝実BEと同じ形）。
      { id: 9, title: "キッズクラス", start: "2026-07-06T17:00:00", end: "2026-07-06T18:00:00", repeatWeekdays: "MO,WE,FR", repeatUntil: null },
      { id: 10, title: "月初ミーティング", start: "2026-07-07T10:00:00", end: null, repeatWeekdays: "TU", repeatUntil: "2026-07-28" },
    ],
    // 自分(デモ太郎)の休み。整合ルール：pending=未来平日、approved=過去の非勤務記録日、rejected=過去(勤務扱い)。
    leaveMine: [
      { id: 1, type: "paid", date_from: "2026-07-15", date_to: "2026-07-15", reason: "私用のため", status: "pending" },
      { id: 2, type: "paid", date_from: "2026-06-25", date_to: "2026-06-25", reason: "通院のため", status: "approved" },
      { id: 3, type: "special", date_from: "2026-07-21", date_to: "2026-07-21", reason: "親族の結婚式に参列するため帰省します。", status: "approved" },
      { id: 4, type: "absence", date_from: "2026-05-15", date_to: "2026-05-15", reason: "体調不良のため", status: "rejected" },
      { id: 5, type: "paid", date_from: "2026-08-12", date_to: "2026-08-12", reason: "", status: "pending" },
    ],
    // 自分(デモ太郎)の時間訂正。整合ルール：勤務した記録日(平日)を対象にする。
    tcMine: [
      { id: 41, field: "clock_in", old_value: "2026-07-01T10:12:00", new_value: "2026-07-01T09:00:00", reason: "打刻を忘れて遅れて押したため", status: "pending" },
      { id: 42, field: "clock_out", old_value: "2026-06-22T19:05:00", new_value: "2026-06-22T20:30:00", reason: "退勤打刻し忘れ", status: "approved" },
      { id: 43, field: "clock_in", old_value: "2026-06-08T09:40:00", new_value: "2026-06-08T09:00:00", reason: "電車遅延の証明書あり。始業時刻に訂正をお願いします。念のため画像も別途共有しました。", status: "rejected" },
      { id: 44, field: "clock_out", old_value: "2026-06-04T18:33:00", new_value: "2026-06-04T19:15:00", reason: "", status: "pending" },
    ],
    // 自分(デモ太郎)の残業（手動申請）。日付＋開始/終了＋理由で登録し、残業時間は開始/終了から計算。状態=申請中/承認/却下。
    otMine: [
      { id: 51, date: "2026-07-10", start: "18:00", end: "20:30", reason: "発表会準備の対応", status: "pending" },
      { id: 52, date: "2026-07-06", start: "18:30", end: "19:30", reason: "備品の在庫確認", status: "pending" },
      { id: 53, date: "2026-05-22", start: "18:00", end: "21:30", reason: "発表会準備の対応が長引いたため", status: "approved" },
      { id: 54, date: "2026-05-27", start: "18:30", end: "20:30", reason: "月末の締め作業", status: "rejected" },
    ],
    payslipsMine: buildPayslips(),
    // 通知バッジの新着数（お知らせ由来の apply/payslip のみ・仕様 通知バッジ_2026-07）。
    // 本番は EmployeeBadgeSeen.seen_at より後に起きた件数を数えるが、デモには「前回見た時刻」が
    // 無いため新着として見せる件数を直接置く（過去分を全部数えると給与明細35 のような
    // 非現実的な数字になり、本番の見え方とも合わない）。該当ページを開くと 0 になる。
    badgeNew: { apply: 2, payslip: 1 },
    // 経営側
    // 休み(経営側)。整合ルール：pending=未来の平日、欠勤/過去分=承認済で過去平日(勤怠も休み表示)、却下=過去平日(出勤扱い)。
    leaveList: [
      { id: 101, employee_name: "佐藤 太郎", type: "paid", date_from: "2026-08-12", date_to: "2026-08-12", reason: "夏季休暇のため", status: "pending" },
      { id: 102, employee_name: "鈴木 一郎", type: "paid", date_from: "2026-08-04", date_to: "2026-08-04", reason: "私用のため", status: "pending" },
      { id: 103, employee_name: "田中 花子", type: "absence", date_from: "2026-06-15", date_to: "2026-06-15", reason: "発熱のため欠勤しました", status: "approved" },
      { id: 104, employee_name: "鈴木 一郎", type: "special", date_from: "2026-08-06", date_to: "2026-08-06", reason: "結婚式参列のため", status: "pending" },
      { id: 105, employee_name: "佐藤 太郎", type: "paid", date_from: "2026-05-01", date_to: "2026-05-01", reason: "GW帰省のため", status: "approved" },
      { id: 106, employee_name: "田中 花子", type: "paid", date_from: "2026-09-10", date_to: "2026-09-10", reason: "通院のため", status: "pending" },
      { id: 107, employee_name: "鈴木 一郎", type: "absence", date_from: "2026-05-27", date_to: "2026-05-27", reason: "体調不良のため欠勤しました", status: "approved" },
      { id: 11, employee_name: "田中 花子", type: "paid", date_from: "2026-07-17", date_to: "2026-07-17", reason: "私用のため", status: "pending" },
      { id: 12, employee_name: "佐藤 太郎", type: "absence", date_from: "2026-06-24", date_to: "2026-06-24", reason: "体調不良のため欠勤しました", status: "approved" },
      { id: 13, employee_name: "鈴木 一郎", type: "special", date_from: "2026-06-19", date_to: "2026-06-19", reason: "親族の不幸により忌引をいただきました。", status: "approved" },
      { id: 14, employee_name: "田中 花子", type: "paid", date_from: "2026-07-03", date_to: "2026-07-03", reason: "通院のため", status: "approved" },
      { id: 15, employee_name: "佐藤 太郎", type: "absence", date_from: "2026-06-26", date_to: "2026-06-26", reason: "体調不良のため", status: "rejected" },
    ],
    // 時間訂正(経営側)。整合ルール：必ず「勤務した過去平日」に置く（週末/未来/休み承認日を避ける）。
    tcList: [
      { id: 121, employee_name: "鈴木 一郎", field: "clock_in", old_value: "2026-06-12T10:20:00", new_value: "2026-06-12T09:00:00", reason: "打刻を忘れていました", status: "pending" },
      { id: 122, employee_name: "田中 花子", field: "clock_out", old_value: "2026-06-25T18:00:00", new_value: "2026-06-25T21:00:00", reason: "退勤打刻し忘れ", status: "pending" },
      { id: 123, employee_name: "佐藤 太郎", field: "clock_in", old_value: "2026-05-18T09:40:00", new_value: "2026-05-18T09:00:00", reason: "電車遅延の証明書あり", status: "pending" },
      { id: 124, employee_name: "鈴木 一郎", field: "clock_out", old_value: "2026-06-16T18:30:00", new_value: "2026-06-16T20:00:00", reason: "退勤打刻忘れ", status: "pending" },
      { id: 125, employee_name: "田中 花子", field: "clock_in", old_value: "2026-06-26T09:25:00", new_value: "2026-06-26T09:00:00", reason: "打刻端末の不具合", status: "pending" },
      { id: 21, employee_name: "田中 花子", field: "clock_in", old_value: "2026-07-02T10:12:00", new_value: "2026-07-02T09:00:00", reason: "打刻を忘れて遅れて押したため", status: "pending" },
      { id: 22, employee_name: "佐藤 太郎", field: "clock_out", old_value: "2026-07-01T18:00:00", new_value: "2026-07-01T20:30:00", reason: "退勤打刻し忘れ", status: "pending" },
      { id: 23, employee_name: "鈴木 一郎", field: "clock_in", old_value: "2026-07-06T09:30:00", new_value: "2026-07-06T09:00:00", reason: "電車遅延の証明書あり。始業時刻に訂正をお願いします。", status: "approved" },
      { id: 24, employee_name: "佐藤 太郎", field: "clock_out", old_value: "2026-06-09T19:00:00", new_value: "2026-06-09T17:30:00", reason: "誤打刻", status: "rejected" },
    ],
    // 残業(経営側・手動申請)。社員が登録した残業申請。日付＋開始/終了＋理由。残業時間は開始/終了から計算。
    otList: [
      { id: 131, employee_name: "鈴木 一郎", date: "2026-06-18", start: "18:00", end: "20:00", reason: "発表会準備の対応", status: "pending" },
      { id: 132, employee_name: "田中 花子", date: "2026-06-30", start: "18:30", end: "20:00", reason: "月末締めの対応", status: "pending" },
      { id: 133, employee_name: "佐藤 太郎", date: "2026-05-22", start: "17:30", end: "20:30", reason: "イベント設営のため", status: "pending" },
      { id: 134, employee_name: "鈴木 一郎", date: "2026-06-22", start: "19:00", end: "20:00", reason: "備品の搬入対応", status: "pending" },
      { id: 135, employee_name: "佐藤 太郎", date: "2026-06-05", start: "18:00", end: "21:30", reason: "発表会リハーサル対応", status: "pending" },
      { id: 31, employee_name: "田中 花子", date: "2026-06-29", start: "18:00", end: "20:30", reason: "月次締めの資料作成が長引いたため", status: "pending" },
      { id: 32, employee_name: "佐藤 太郎", date: "2026-06-23", start: "18:30", end: "19:30", reason: "備品の在庫整理", status: "pending" },
      { id: 33, employee_name: "鈴木 一郎", date: "2026-07-03", start: "18:00", end: "21:30", reason: "発表会準備の対応", status: "approved" },
      { id: 34, employee_name: "田中 花子", date: "2026-06-16", start: "18:00", end: "18:45", reason: "軽微な残作業", status: "approved" },
    ],
    // 実BE(_employee_brief)は is_active / is_executive を返す。形を揃えないと
    // 「デモでは出るが本番では出ない」列が生まれる（シフト・有休の設定対象と勤怠ロスターは
    // 経営者を除外する＝ !is_executive で絞るため、フィールドが無いと常に全員が出てしまう）。
    empList: [
      { id: 1, name: "田中 花子", is_active: true, is_executive: false },
      { id: 2, name: "佐藤 太郎", is_active: true, is_executive: false },
      { id: 3, name: "鈴木 一郎", is_active: true, is_executive: false },
      { id: 4, name: "山田 次郎", is_active: false, is_executive: false },
    ],
    shifts: {
      weekdays_ja: ["月", "火", "水", "木", "金", "土", "日"],
      patterns: [
        { id: 101, weekday: 0, start_time: "10:00", end_time: "19:00", default_mode: "office", is_dayoff: false },
        { id: 102, weekday: 1, start_time: "10:00", end_time: "19:00", default_mode: "office", is_dayoff: false },
        { id: 103, weekday: 2, start_time: "13:00", end_time: "19:00", default_mode: "remote", is_dayoff: false },
        { id: 104, weekday: 3, start_time: "10:00", end_time: "19:00", default_mode: "office", is_dayoff: false },
        { id: 105, weekday: 4, start_time: "12:30", end_time: "21:30", default_mode: "remote", is_dayoff: false },
        { id: 106, weekday: 5, start_time: "", end_time: "", default_mode: "office", is_dayoff: true },
        { id: 107, weekday: 6, start_time: "", end_time: "", default_mode: "office", is_dayoff: true },
      ],
      exceptions: [
        { id: 201, date: "2026-07-20", is_dayoff: true, start_time: "", end_time: "", mode: null },
        { id: 202, date: "2026-07-22", is_dayoff: false, start_time: "12:00", end_time: "18:00", mode: "remote" },
      ],
    },
    payslipList: buildPayslipList(),
    // TODO（LINE抽出/手動追加の想定）。ホームと TODO ボードの両方がこの1配列を参照する（母集合を一元化）。
    // status: open|doing|done、assignee: null=担当なし / "自分"=ログイン本人 / その他=他メンバー、source: line|manual。
    todos: [
      // 未対応（open）
      { id: 1, title: "スタジオAの鏡の張り替え業者に連絡", due: "2026-07-03", source: "line", status: "open", assignee: null, memos: [] },
      { id: 2, title: "発表会チラシの校正（第2稿）を確認", due: "2026-07-05", source: "line", status: "open", assignee: null,
        memos: [{ mid: "seed-m1", by: "里奈", at: "07/01 10:20", text: "印刷所からデータ届いてます" }] },
      { id: 3, title: "新規体験レッスンの備品（マット5枚）発注", due: null, source: "manual", status: "open", assignee: null, memos: [] },
      { id: 4, title: "発表会の会場（市民ホール）予約を最終確認", due: "2026-07-10", source: "line", status: "open", assignee: null, memos: [] },
      { id: 5, title: "更衣室のハンガーを補充する", due: null, source: "manual", status: "open", assignee: null, memos: [] },
      { id: 6, title: "体験レッスンの問い合わせ（3件）に返信", due: "2026-07-08", source: "line", status: "open", assignee: null, memos: [] },
      { id: 7, title: "音響設備のワイヤレスマイクの電池を交換", due: "2026-07-09", source: "manual", status: "open", assignee: "鈴木", memos: [] },
      { id: 8, title: "生徒アンケートの結果を集計してまとめる", due: "2026-07-14", source: "line", status: "open", assignee: null,
        memos: [{ by: "佐藤", at: "07/02 15:40", text: "回答は昨日で締め切りました" }] },
      { id: 9, title: "月謝の未納者（2名）へリマインド連絡", due: "2026-07-06", source: "line", status: "open", assignee: null, memos: [] },
      { id: 10, title: "ウォーターサーバーの水を発注", due: null, source: "manual", status: "open", assignee: null, memos: [] },
      // 対応中（doing）
      { id: 11, title: "7月分シフトの希望を全員に督促", due: "2026-07-02", source: "line", status: "doing", assignee: "小村",
        memos: [{ by: "小村", at: "07/01 09:05", text: "LINEで一斉送信済み。未回答は3名" }] },
      { id: 12, title: "エアコン点検の日程調整", due: "2026-07-08", source: "manual", status: "doing", assignee: "自分", memos: [] },
      { id: 13, title: "新規入会者の名簿をシステムに登録", due: "2026-07-07", source: "manual", status: "doing", assignee: "自分",
        memos: [{ by: "自分", at: "07/05 11:00", text: "残り5名分" }] },
      { id: 14, title: "発表会の衣装サイズを全員分ヒアリング", due: "2026-07-12", source: "line", status: "doing", assignee: "里奈", memos: [] },
      { id: 15, title: "講師5名の6月分の交通費を精算", due: "2026-07-05", source: "manual", status: "doing", assignee: "自分", memos: [] },
      // 完了（done）
      { id: 16, title: "先月の売上レポートを共有", due: "2026-06-30", source: "line", status: "done", assignee: "誠司",
        memos: [{ by: "誠司", at: "06/30 18:40", text: "ダッシュボードに反映済み" }] },
      { id: 17, title: "駐車場の契約更新書類を提出", due: "2026-06-28", source: "manual", status: "done", assignee: "自分", memos: [] },
      { id: 18, title: "Instagramの今週の投稿を予約設定", due: "2026-07-01", source: "line", status: "done", assignee: "里奈", memos: [] },
      { id: 19, title: "消防設備の点検を予約", due: "2026-06-25", source: "manual", status: "done", assignee: "小村", memos: [] },
      { id: 20, title: "新年度パンフレットのデザインを外注へ依頼", due: "2026-06-27", source: "line", status: "done", assignee: "自分", memos: [] },
    ],
    // 承認待ち候補（会話→予定/TODO）。振り分けUIの確認用。BEの _suggestion_dict と同じ形。
    suggestions: [
      { id: 801, kind: "event", title: "山本様と打ち合わせ", start: "2026-07-15T10:30:00+09:00", end: null, allDay: false, sourceText: "明日は10:30から山本様と打ち合わせがあります", speaker: "里奈", status: "pending", createdAt: "2026-07-14T11:43:00+09:00" },
      { id: 802, kind: "event", title: "社員研修", start: "2026-07-25T09:00:00+09:00", end: null, allDay: true, sourceText: "7/25 社員研修やります", speaker: "誠司", status: "pending", createdAt: "2026-07-14T12:10:00+09:00" },
      { id: 803, kind: "todo", title: "備品（マット5枚）を発注", start: null, end: null, allDay: false, sourceText: "マット5枚発注お願いします", speaker: "小村", status: "pending", createdAt: "2026-07-14T12:20:00+09:00" },
    ],
    // 有休付与（社員×年度）。消化日数は leaveList（承認済み・有給）から集計するため保持しない。
    paidGrants: [
      { employee_id: 1, fiscal_year: 2026, granted_days: 14 },
      { employee_id: 1, fiscal_year: 2025, granted_days: 12 },
      { employee_id: 2, fiscal_year: 2026, granted_days: 12 },
      { employee_id: 2, fiscal_year: 2025, granted_days: 11 },
      { employee_id: 3, fiscal_year: 2026, granted_days: 10 },
    ],
    seq: 900,
  };
}

let state = load();
function load() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      // seed を更新したら _v が変わる → 古い保存データは破棄して作り直す。
      if (parsed && parsed._v === SEED_VERSION) return parsed;
    }
  } catch (e) { /* ignore */ }
  const s = initialState();
  save(s);
  return s;
}
function save(s) { try { localStorage.setItem(LS_KEY, JSON.stringify(s || state)); } catch (e) { /* ignore */ } }
function persist() { save(state); }

// ── 外部（デモ操作ウィジェット）から使う ──
export function getRole() { return state.role; }
export function setRole(role) { state.role = role === "executive" ? "executive" : "employee"; persist(); }
export function reset() { state = initialState(); persist(); }
export function isWorking() { return state.today.status === "working"; }

export function clockIn() {
  const id = ++state.seq;
  state.curAttId = id;
  state.today = {
    ...state.today, status: "working", in_office: true, work_mode: "office",
    clock_in: nowHM(), clock_out: null, elapsed_min: 0,
  };
  state.attendances.unshift({ id, clock_in: nowISO(), clock_out: null, work_mode: "office", in_office: true, status: "open", daily_report: "" });
  state.recent.unshift({ date: todayMD(), weekday: todayWD(), clock_in: nowHM(), clock_out: null, work_mode: "office", status: "open" });
  persist();
}
export function clockOut(report) {
  state.today = { ...state.today, status: "closed", clock_out: nowHM() };
  const att = state.attendances.find((a) => a.id === state.curAttId);
  if (att) { att.clock_out = nowISO(); att.status = "closed"; att.daily_report = report || "本日の業務を実施しました。"; }
  if (state.recent[0] && state.recent[0].status === "open") { state.recent[0].clock_out = nowHM(); state.recent[0].status = "closed"; }
  persist();
}

// ── fetch シムが使う: (method, pathname, query, body) → {status, json} ──
function ok(json) { return { status: 200, json }; }
// デモの静的レコードは employee_name のみ持つため、配信時に empList から employee_id を補う（#10）。
function empIdByName(name) {
  const e = state.empList.find((x) => x.name === name);
  return e ? e.id : null;
}
function withEmpId(r) {
  return r.employee_id != null ? r : { ...r, employee_id: empIdByName(r.employee_name) };
}
// 時間訂正に出勤–退勤ペア(before/after)＋対象日を補う（実BE _timecorr_dict 相当・#12）。
// デモは打刻あり訂正が主なので未訂正側(相方)はプレースホルダの定時(09:00/19:00)。date 有=打刻無し日は相方 null。
function withTcPair(r) {
  if (r.in_before !== undefined) return r;
  const t = (iso) => (iso ? String(iso).slice(11, 16) : null);
  const target = r.date || (r.new_value ? String(r.new_value).slice(0, 10) : null);
  const noPunch = !!r.date;
  let inB, outB, inA, outA;
  if (r.field === "clock_in") {
    inB = t(r.old_value); inA = t(r.new_value);
    outB = outA = noPunch ? null : "19:00";
  } else {
    outB = t(r.old_value); outA = t(r.new_value);
    inB = inA = noPunch ? null : "09:00";
  }
  return { ...r, target_date: target, in_before: inB, out_before: outB, in_after: inA, out_after: outA };
}
function byStatus(list, query) {
  const st = query.get("status");
  const rows = (st && st !== "all") ? list.filter((r) => r.status === st) : list;
  return { results: rows.map(withEmpId) };
}

// ── 有休（年度＝日本の年度・4月始まり）の集計ヘルパー ──
function fiscalYearOf(d) { const m = d.getMonth() + 1; return m >= 4 ? d.getFullYear() : d.getFullYear() - 1; }
function fyRange(fy) { return { from: `${fy}-04-01`, to: `${fy + 1}-03-31` }; }
// [from,to] と [lo,hi] の重なり日数（両端含む）。YYYY-MM-DD の文字列比較でOK。
function overlapDays(from, to, lo, hi) {
  const s = from < lo ? lo : from;
  const e = to > hi ? hi : to;
  if (s > e) return 0;
  return Math.round((new Date(`${e}T00:00:00`) - new Date(`${s}T00:00:00`)) / 86400000) + 1;
}
// 指定社員・年度の有給消化日数（承認済み・type=paid の休みを年度範囲で数える）。
function paidUsedDays(employeeName, fy) {
  const { from, to } = fyRange(fy);
  return state.leaveList
    .filter((x) => x.employee_name === employeeName && x.type === "paid" && x.status === "approved")
    .reduce((sum, x) => sum + overlapDays(x.date_from, x.date_to, from, to), 0);
}
// 社員の年度別 有休サマリ（付与・消化・残）。当年度は付与未設定でも1行必ず出す。
function paidLeaveSummary(employeeId) {
  const emp = state.empList.find((e) => e.id === employeeId);
  const name = emp ? emp.name : "";
  const grants = state.paidGrants.filter((g) => g.employee_id === employeeId);
  const curFy = fiscalYearOf(new Date());
  const years = new Set(grants.map((g) => g.fiscal_year));
  years.add(curFy);
  return [...years]
    .sort((a, b) => b - a)
    .map((fy) => {
      const g = grants.find((x) => x.fiscal_year === fy);
      const granted = g ? g.granted_days : 0;
      const used = paidUsedDays(name, fy);
      return { fiscal_year: fy, granted_days: granted, used_days: used, remaining_days: granted - used };
    });
}

// ── 通知バッジ（仕様 docs/mypage/通知バッジ仕様_2026-07.md） ──
// 消える条件が正反対な2種類がある。本番BEと同じ条件をデモでも再現する。
//   状態由来 (home/attendance/todo): 開いても消えず、処理して初めて減る。
//   お知らせ由来 (apply/payslip): 開いた＝既読で消える。
// 経営者の承認待ち（休み/時間訂正/残業）。ホームの帯と勤怠履歴バッジの両方がこれを使う
// ＝同じ画面で数字が食い違わない（本番BEも同じ3テーブルを status='pending' で数える）。
function execApprovals() {
  const pending = (list) => list.filter((x) => x.status === "pending").length;
  return {
    leave: pending(state.leaveList),
    correction: pending(state.tcList),
    overtime: pending(state.otList),
  };
}

// 開いた＝見た、で消える（本番は該当ページのGETの副作用でサーバが既読にする）。
function markSeen(key) {
  if (state.badgeNew[key] === 0) return;
  state.badgeNew[key] = 0;
  persist();
}

function badgeCounts() {
  // 状態由来: デモでも本番と同じ条件でデータから数える（開いても消えず、処理して減る）。
  const counts = {
    // ホーム: 予定/TODOにまだ振り分けていない候補（全社共有）。
    home: state.suggestions.filter((s) => s.status === "pending").length,
    // TODO: 未対応の全社件数。担当者では絞らない＝両ロール同じ数字。
    todo: state.todos.filter((t) => t.status === "open").length,
  };
  if (state.role === "executive") {
    // 勤怠履歴: 全社の承認待ち申請。経営者の承認の入口は勤怠履歴の右パネルなのでここに付く。
    const a = execApprovals();
    counts.attendance = a.leave + a.correction + a.overtime;
  } else {
    // お知らせ由来: 前回見たあとの新着（申請の承認結果 / 届いた給与明細）。
    counts.apply = state.badgeNew.apply;
    counts.payslip = state.badgeNew.payslip;
  }
  return counts;
}

export function handle(method, pathname, query, body) {
  const path = pathname.replace(/\/$/, "");
  const M = method.toUpperCase();

  if (M === "GET") {
    switch (path) {
      case "/api/employee/me":
        return ok(state.role === "executive"
          ? { name: "デモ 社長", is_executive: true, office: "本社" }
          : { name: "デモ 太郎", is_executive: false, office: "本社" });
      case "/api/employee/home":
        return ok({
          user: { name: state.role === "executive" ? "デモ 社長" : "デモ 太郎", line_linked: true },
          today: state.today,
          // 承認待ちは実データ(leaveList/tcList/otList)から数える。本番BEも同じテーブルを
          // 数えるため、ホームの帯とサイドバーの勤怠履歴バッジは必ず一致する
          // （旧モックは 3/2/2 固定で、実データ19件とも勤怠履歴バッジとも食い違っていた）。
          my_request: state.role === "executive"
            ? { executive: true, approvals: execApprovals(), pending_count: 0, latest: "" }
            : { executive: false, approvals: { leave: 0, correction: 0, overtime: 0 }, pending_count: 1, latest: "休み申請（7/15）を申請中" },
          week: [
            { weekday: "月", day: 29, is_today: false, shift: { start: "10:00", end: "19:00", mode: "office", is_dayoff: false } },
            { weekday: "火", day: 30, is_today: false, shift: { start: "13:00", end: "19:00", mode: "remote", is_dayoff: false } },
            { weekday: "水", day: 1, is_today: true, shift: { start: "09:00", end: "18:00", mode: "office", is_dayoff: false } },
            { weekday: "木", day: 2, is_today: false, shift: { start: "10:00", end: "19:00", mode: "office", is_dayoff: false } },
            { weekday: "金", day: 3, is_today: false, shift: { start: "12:30", end: "21:30", mode: "remote", is_dayoff: false } },
            { weekday: "土", day: 4, is_today: false, shift: { is_dayoff: true } },
            { weekday: "日", day: 5, is_today: false, shift: { is_dayoff: true } },
          ],
          today_events: [{ time: "14:00", title: "発表会リハーサル" }, { time: "18:00", title: "スタッフMTG" }],
          recent: state.recent,
          // 今月サマリ（ホーム上部の帯）。work_minutes は分。本番はBEが当月の実績から集計する。
          month_summary: { work_days: 12, work_minutes: 5790, paid_leave_days: 12 },
        });
      // 実BEと同じく months（記録のある月・上限に依らず完全）を返し、?ym= でその月だけ返す。
      // 揃えないと「demoでは全月出るが本番では出ない」等の食い違いが出る。
      case "/api/employee/attendances": {
        const ymOfIso = (iso) => (typeof iso === "string" && iso.length >= 7 ? iso.slice(0, 4) + iso.slice(5, 7) : null);
        const months = [...new Set(state.attendances.map((a) => ymOfIso(a.clock_in)).filter(Boolean))].sort();
        const want = (query.get("ym") || "").replace("-", "");
        const rows = want ? state.attendances.filter((a) => ymOfIso(a.clock_in) === want) : state.attendances;
        const lim = parseInt(query.get("limit") || "1000", 10);
        return ok({ results: rows.slice(0, Number.isNaN(lim) ? 1000 : Math.max(1, lim)), months, linked: true });
      }
      case "/api/employee/attendances/by-date": {
        const date = query.get("date") || ymd(new Date());
        return ok({ date, results: demoAttendanceByDate(date) });
      }
      case "/api/employee/attendances/by-month": {
        const now = new Date();
        const ym = query.get("ym") || `${now.getFullYear()}${p2(now.getMonth() + 1)}`;
        return ok(demoAttendanceByMonth(ym));
      }
      case "/api/employee/leave/unavailable": {
        // 休み申請で選べない日: シフト休（デモ=週末）＋祝日。過去日も申請できる（事後申請）。
        // 過去12ヶ月〜約14ヶ月先の窓を返す（カレンダー下限=過去12ヶ月と整合）。本番は BE がシフトパターン＋祝日(jpholiday)で返す。
        const off = [];
        const holidays = {}; // { "YYYY-MM-DD": 祝日名 }
        const now = new Date();
        const start = new Date(now);
        start.setMonth(start.getMonth() - 12);
        start.setDate(1);
        // 終端は「今日」から+14ヶ月。start(=12ヶ月前)に +14 すると約2ヶ月先までしか
        // 返らず、実BE(_shift_months(当月1日, +14))と12ヶ月ズレる。ズレると demo では
        // 土日・祝日がグレーアウトされず選べてしまい、本番と逆の結論でレビューしてしまう。
        const end = new Date(now.getFullYear(), now.getMonth() + 14, 0);
        for (const d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
          const ds = ymd(d);
          if (HOLIDAYS[ds]) holidays[ds] = HOLIDAYS[ds];
          else if (d.getDay() === 0 || d.getDay() === 6) off.push(ds); // 週末=シフト休（デモ）
        }
        return ok({ off, holidays });
      }
      case "/api/employee/applications": {
        // 経営者の勤怠一覧・右パネル用：申請（休み/時間訂正/残業）をまとめて返す。
        // 承認待ち／承認済み／却下を含める（残業の recorded=記録のみ は申請ではないので除外）。
        // フロント側でフィルタタブにより絞り込む。
        const inScope = (s) => s === "pending" || s === "approved" || s === "rejected";
        return ok({ results: [
          ...state.leaveList.filter((x) => inScope(x.status)).map((x) => ({ ...withEmpId(x), kind: "leave" })),
          ...state.tcList.filter((x) => inScope(x.status)).map((x) => ({ ...withTcPair(withEmpId(x)), kind: "correction" })),
          ...state.otList.filter((x) => inScope(x.status)).map((x) => ({ ...withEmpId(x), kind: "overtime" })),
        ] });
      }
      case "/api/employee/calendar": return ok({ results: expandCalendar(state.calendar, query) });
      case "/api/employee/notifications": return ok(badgeCounts());
      case "/api/employee/suggestions": return ok({ results: state.suggestions });
      // 実BEと同じく ?status=open,doing で絞る（ホームが使う）。未知の値は無視して全件。
      // 対応しないと「demoでは完了TODOがホームに出ないのに実BEでは出る」等の食い違いが出る。
      case "/api/employee/todos": {
        const want = (query.get("status") || "").split(",").filter((s) => ["open", "doing", "done"].includes(s));
        return ok({ results: want.length ? state.todos.filter((t) => want.includes(t.status)) : state.todos });
      }
      // 申請ハブ3タブ・給与明細の GET は、本番と同じくバッジを既読にする副作用を持つ。
      case "/api/employee/leave/mine": markSeen("apply"); return ok({ results: state.leaveMine });
      case "/api/employee/time-correction/mine": markSeen("apply"); return ok({ results: state.tcMine.map(withTcPair) });
      case "/api/employee/overtime/mine": markSeen("apply"); return ok({ results: state.otMine });
      case "/api/employee/payslips/mine":
        // 各行に閲覧URL（月別のデモPDF）を持たせる＝フロントは追加取得せず開ける（本番と同じ形）。
        markSeen("payslip");
        return ok({ results: state.payslipsMine.map((p) => ({ ...p, url: `${process.env.PUBLIC_URL || ""}/demo/payslip-${p.year_month}.pdf` })) });
      case "/api/employee/leave/list": return ok(byStatus(state.leaveList, query));
      case "/api/employee/time-correction/list": { const r = byStatus(state.tcList, query); return ok({ results: r.results.map(withTcPair) }); }
      case "/api/employee/overtime/list": return ok(byStatus(state.otList, query));
      case "/api/employee/list": return ok({ results: state.empList });
      case "/api/employee/shifts": return ok(state.shifts);
      case "/api/employee/paid-leave": {
        // 有休設定：社員の年度別サマリ（付与・消化・残）。
        const eid = Number(query.get("employee_id"));
        return ok({ results: paidLeaveSummary(eid) });
      }
      case "/api/employee/payslips/list":
        // 管理側・社員側とも各行に閲覧URL（月別の実PDF）を持たせる（フロントは追加取得しない）。
        return ok({ results: state.payslipList.map((p) => ({ ...withEmpId(p), url: `${process.env.PUBLIC_URL || ""}/demo/payslip-${p.year_month}.pdf` })) });
      case "/api/employee/team-status":
        // サイドバー用：本日のスタッフ勤務状況。全アクティブ社員を並べ、勤務中(open)だけ緑・他は closed。
        // （本番APIは非経営者の在籍社員を id降順で返し、出勤中のみ open）。並びは本番に合わせ逆順。
        return ok({ results: demoAttendanceByDate(ymd(new Date())).map((r) => ({ name: r.employee_name, status: r.status === "open" ? "open" : "closed" })).reverse() });
      default: return ok({ results: [] });
    }
  }

  // POST 系
  const id = body && body.id;
  const decide = (list) => { const r = list.find((x) => x.id === id); if (r) r.status = body.action === "approve" ? "approved" : "rejected"; persist(); return ok({ ok: true }); };
  const removeFrom = (key) => { state[key] = state[key].filter((x) => x.id !== id); persist(); return ok({ ok: true }); };

  switch (path) {
    case "/api/login": return ok({ ok: true });
    // LINE(LIFF)打刻のデモ用（lineDemo のリッチメニュー経由）。
    case "/api/employee/clock-in": clockIn(); return ok({ ok: true });
    case "/api/employee/clock-out": clockOut(body && body.daily_report); return ok({ ok: true });
    // PC打刻（ホームの打刻カード・セッション認証）。lat/lng は受け取るがデモでは事務所固定。
    case "/api/employee/self/clock-in": clockIn(); return ok({ ok: true });
    case "/api/employee/self/clock-out": clockOut(body && body.daily_report); return ok({ ok: true });
    // 日報の再編集（退勤後）。対象レコードの daily_report を更新する。
    case "/api/employee/self/report": {
      const r = state.attendances.find((a) => a.id === id);
      if (r) r.daily_report = (body && body.daily_report) || "";
      persist();
      return ok({ ok: true });
    }
    case "/api/employee/leave/decide": return decide(state.leaveList);
    case "/api/employee/time-correction/decide": return decide(state.tcList);
    case "/api/employee/overtime/decide": return decide(state.otList);
    case "/api/employee/leave/cancel": return removeFrom("leaveMine");
    case "/api/employee/time-correction/cancel": return removeFrom("tcMine");
    case "/api/employee/payslips/upload": {
      // デモはファイル本体を受け取れないため、クエリの社員名・年月で1件追加する（同一枠は置換）。
      // kind=bonus のときは賞与＝「社員×支給月×賞与名(label)」を1枠として置換する（同月に複数の賞与名を持てる）。
      const ename = query.get("employee_name") || "";
      const ym = query.get("year_month") || "";
      const kind = query.get("kind") || "monthly";
      const label = query.get("label") || "";
      const isBonus = kind === "bonus";
      if (ename && ym && (!isBonus || label)) {
        state.payslipList = state.payslipList.filter((p) => {
          const same = p.employee_name === ename && p.year_month === ym;
          if (!same) return true;
          // 賞与アップロード＝同じ賞与名の枠だけ置換。月次アップロード＝月次だけ置換し賞与は残す。
          if (isBonus) return !(p.kind === "bonus" && p.label === label);
          return p.kind === "bonus";
        });
        const rec = { id: ++state.seq, employee_name: ename, year_month: ym, uploaded_at: new Date().toISOString() };
        if (isBonus) { rec.kind = "bonus"; rec.label = label; }
        state.payslipList.push(rec);
        persist();
      }
      return ok({ ok: true });
    }
    case "/api/employee/payslips/delete": return removeFrom("payslipList");
    case "/api/employee/payslips/bonus-frame/delete": {
      // 賞与枠（支給月＋賞与名）を一括削除（#11）。BE と同じく該当枠の全社員分をまとめて消す。
      const ym = body && body.year_month;
      const flabel = body && body.label;
      const before = state.payslipList.length;
      state.payslipList = state.payslipList.filter((p) => !(p.kind === "bonus" && p.year_month === ym && p.label === flabel));
      persist();
      return ok({ status: "ok", deleted: before - state.payslipList.length });
    }
    case "/api/employee/overtime": state.otMine.unshift({ id: ++state.seq, date: body.date, start: body.start, end: body.end, reason: body.reason || "", status: "pending" }); persist(); return ok({ ok: true });
    case "/api/employee/overtime/cancel": return removeFrom("otMine");
    case "/api/employee/leave": state.leaveMine.unshift({ id: ++state.seq, ...body, status: "pending" }); persist(); return ok({ ok: true });
    case "/api/employee/time-correction": {
      // 打刻がある日=attendance_idで訂正（元の値を履歴に控える）／打刻が無い日=dateで新規登録（old_value=null）。
      const att = body.attendance_id ? state.attendances.find((a) => a.id === Number(body.attendance_id)) : null;
      const oldVal = att ? att[body.field] : null;
      state.tcMine.unshift({ id: ++state.seq, field: body.field, date: body.attendance_id ? null : (body.date || null), old_value: oldVal, new_value: body.new_value, reason: body.reason || "", status: "pending" });
      persist();
      return ok({ ok: true });
    }
    case "/api/employee/calendar/create": state.calendar.push({ id: ++state.seq, ...calendarFields(body) }); persist(); return ok({ ok: true });
    case "/api/employee/calendar/update": { const r = state.calendar.find((x) => x.id === id); if (r) Object.assign(r, calendarFields(body)); persist(); return ok({ ok: true }); }
    case "/api/employee/calendar/reject": return removeFrom("calendar");
    case "/api/employee/calendar/ics-token": return ok({ path: "/api/employee/calendar/ics/demo-token.ics" });
    // 承認待ちの振り分け：todo/event/reject いずれも一覧から外す（デモは確定先の作成まではしない）
    case "/api/employee/suggestions/resolve": return removeFrom("suggestions");
    case "/api/employee/shifts/pattern": { const r = state.shifts.patterns.find((x) => x.weekday === body.weekday); if (r) Object.assign(r, { start_time: body.start_time, end_time: body.end_time, default_mode: body.default_mode, is_dayoff: body.is_dayoff }); persist(); return ok({ id: r ? r.id : ++state.seq, ...body }); }
    case "/api/employee/shifts/exception": state.shifts.exceptions.push({ id: ++state.seq, date: body.date, is_dayoff: body.is_dayoff, start_time: body.start_time || "", end_time: body.end_time || "", mode: body.mode || null }); persist(); return ok({ ok: true });
    case "/api/employee/shifts/exception/delete": state.shifts.exceptions = state.shifts.exceptions.filter((x) => x.id !== id); persist(); return ok({ ok: true });
    case "/api/employee/paid-leave": {
      // 有休付与の設定（社員×年度をupsert）。返り値は更新後の当該年度サマリ。
      const eid = Number(body.employee_id);
      const fy = Number(body.fiscal_year);
      const days = Math.max(0, Number(body.granted_days) || 0);
      const g = state.paidGrants.find((x) => x.employee_id === eid && x.fiscal_year === fy);
      if (g) g.granted_days = days;
      else state.paidGrants.push({ employee_id: eid, fiscal_year: fy, granted_days: days });
      persist();
      const emp = state.empList.find((e) => e.id === eid);
      const used = paidUsedDays(emp ? emp.name : "", fy);
      return ok({ fiscal_year: fy, granted_days: days, used_days: used, remaining_days: days - used });
    }
    // TODO（全員共有）。追加/状態変更/編集/削除/メモ。自分のものは "自分" で保持（共通カードが自分判定する）。
    case "/api/employee/todos":
      state.todos.unshift({ id: ++state.seq, title: body.title, due: body.due || null, source: "manual", status: "open", assignee: null, memos: [] });
      persist(); return ok({ ok: true });
    case "/api/employee/todos/update": {
      const r = state.todos.find((x) => x.id === id);
      if (r) {
        if (body.title !== undefined) r.title = body.title;
        if (body.due !== undefined) r.due = body.due || null;
        if (body.status !== undefined) {
          r.status = body.status;
          if ((body.status === "doing" || body.status === "done") && !r.assignee) r.assignee = "自分";
        }
      }
      persist(); return ok({ ok: true });
    }
    case "/api/employee/todos/delete": return removeFrom("todos");
    case "/api/employee/todos/memo": {
      const r = state.todos.find((x) => x.id === id);
      // 実BEと同じく mid（安定ID）を採番する。無いと削除が効かない。
      if (r) r.memos = [...(r.memos || []), { mid: `m${++state.seq}`, by: "自分", at: "今", text: body.text }];
      persist(); return ok({ ok: true });
    }
    case "/api/employee/todos/memo/delete": {
      const r = state.todos.find((x) => x.id === id);
      // 実BEと同じく mid で消す（添字だと同時編集で別のメモが消える）
      if (r && body.mid) r.memos = (r.memos || []).filter((m) => m.mid !== body.mid);
      persist(); return ok({ ok: true });
    }
    default: return ok({ ok: true });
  }
}
